/**
 * The commented and "set" initial values are set in place should anyone
 * need to debug the app from step 1. The hardcoded values allow
 * the dev to quickly move from the start without giving much
 * thought on what needs to be set to advance all all values
 * are valid for the applicacion in the dev. environment.
 *
 * Before submitting, tho, be sure to check if the backend
 * can or will accept as some are checked for validity
 * and unicity in the server, even when they pass our tests.
 */

// export const APP_INITIAL_VALUES = {
//   isAppLoading: false,
//   ids: {
//     idPaso: 1,
//     idTramite: '00000000-0000-0000-0000-000000000000',
//     idDireccion: '00000000-0000-0000-0000-000000000000',
//     idPoliza: '00000000-0000-0000-0000-000000000000',
//     idContratante: '00000000-0000-0000-0000-000000000000',
//   },
//   poliza: {
//     numero: '',
//     folio: '',
//   },
//   factura: {
//     intentosTimbrado: 0,
//   },
//   docs: [],
//   form1: {
//     Nombre: 'ricardo',
//     Paterno: 'fernandez',
//     Materno: 'romero',
//     Telefono: '3213213211',
//     Email: '',
//     FechaNacimiento: '01/01/1981',
//     isAceptTCGD: true,
//     AvisoPrivacidad: true,
//   },
//   form3: {
//     insuredAmount: 100000, // Amount to be received by the client
//     insuredAmountRangeValue: '3', // id to match the amount in the above range
//     paymentPeriodicity: 'anual', // displayed periodicity show to the user,
//     paymentPeriodicityRangeValue: '4', // id to match the name of the period of charges,
//     clientTotalPayment: 0, // the total amount to be charged to the credit card.
//   },
//   form4: {
//     name: 'riki',
//     email: 'correo@correo.com',
//     cardNumber: '4111111111111111',
//     cardYear: '22',
//     cardMonth: '12',
//     cardCode: '110',
//   },
//   form5: {
//     selectedSex: 'm',
//     nationality: 'MX', // not really used
//     birthCountry: 'MX', // not really used
//     birthState: '',
//     email: '',
//     rfc: '',
//     curp: '',
//     street: 'c',
//     noExt: '1',
//     noInt: '1',
//     postalCode: '53040',
//     colony: '',
//     municipality: '',
//     state: '',
//     samePerson: 'yes',
//     wantInvoice: 'no',
//     taxRegime: '',
//     insuredName: 'Máximo',
//     insuredFatherLastName: 'Peralta',
//     insuredMotherLastName: 'Paleta',
//     insuredBirthDate: '01/01/1981',
//     insuredPhone: '9876543219',
//     insuredEmail: 'asegurado@correo.com',
//     insuredMaritalStatus: 'colony1',
//     insuredSelectedSex: 'f',
//     insuredNationality: 'MX', // not really used
//     insuredBirthCountry: 'MX', // not really used
//     insuredBirthState: 'AS',
//     insuredCurp: '',
//     insuredRfc: '',
//     insuredStreet: 'Siempreviva',
//     insuredNoExt: '12',
//     insuredNoInt: '13',
//     insuredPostalCode: '01000',
//     insuredColony: 'insuredColony1',
//     insuredMunicipality: 'colony1',
//     insuredState: 'colony5',
//   },
//   form6: {
//     taxRegime: '',
//     postalCode: '04800',
//     rfc: 'FERR810716RJ8',
//     email: 'correo@correo.com',
//   },
// };

export const APP_INITIAL_VALUES = {
  isAppLoading: false,
  ids: {
    idPaso: 1,
    idTramite: '00000000-0000-0000-0000-000000000000',
    idDireccion: '00000000-0000-0000-0000-000000000000',
    idPoliza: '00000000-0000-0000-0000-000000000000',
    idContratante: '00000000-0000-0000-0000-000000000000',
  },
  poliza: {
    numero: '',
    folio: '',
  },
  factura: {
    intentosTimbrado: 0,
  },
  docs: [],
  form1: {
    Nombre: '',
    Paterno: '',
    Materno: '',
    Telefono: '',
    Email: '',
    FechaNacimiento: '',
    isAceptTCGD: false,
    AvisoPrivacidad: false,
  },
  form2: {
    question1: '',
    question2: '',
    question3option1: '',
    question3option2: '',
    question3option3: '',
    question3option4: '',
    question4: '',
  },
  form3: {
    insuredAmount: 100000, // Amount to be received by the client
    insuredAmountRangeValue: '3', // id to match the amount in the above range
    paymentPeriodicity: 'anual', // displayed periodicity show to the user,
    paymentPeriodicityRangeValue: '4', // id to match the name of the period of charges,
    clientTotalPayment: 0, // the total amount to be charged to the credit card.
  },
  form4: {
    name: '',
    email: '',
    cardNumber: '',
    cardYear: '',
    cardMonth: '',
    cardCode: '',
  },
  form5: {
    selectedSex: '',
    nationality: '', // not really used
    birthCountry: '', // not really used
    birthState: '',
    email: '',
    rfc: '',
    curp: '',
    street: '',
    noExt: '',
    noInt: '',
    postalCode: '',
    colony: '',
    municipality: '',
    state: '',
    samePerson: '',
    wantInvoice: '',
    taxRegime: '',
    insuredName: '',
    insuredFatherLastName: '',
    insuredMotherLastName: '',
    insuredBirthDate: '',
    insuredPhone: '',
    insuredEmail: '',
    insuredMaritalStatus: '',
    insuredSelectedSex: '',
    insuredNationality: '', // not really used
    insuredBirthCountry: '', // not really used
    insuredBirthState: '',
    insuredCurp: '',
    insuredRfc: '',
    insuredStreet: '',
    insuredNoExt: '',
    insuredNoInt: '',
    insuredPostalCode: '',
    insuredColony: '',
    insuredMunicipality: '',
    insuredState: '',
    insuredPrivacyStatements: false,
  },
};
